import { AxiosResponse } from 'axios';

import { ApiVersion } from '@/config';
import {
  IVehicle,
  IVehicleColor,
  IVehicleForm,
  IVehicleLicenseType,
  IVehicleLicenseState,
  IVehicleMake,
  IVehicleModel,
  // VehicleType,
} from '@/models';

import { http } from './http';
import { IGetParams, IListResponse, IPaginatedListResponse } from './types';

export const VehicleApi = {
  getVehicles: (
    params?: IGetParams,
  ): Promise<AxiosResponse<IPaginatedListResponse<IVehicle>>> => {
    return http.get(`api/${ApiVersion.V1}/vehicles/vehicles`, { params });
  },
  getVehicle: (id: string): Promise<AxiosResponse<IVehicle>> => {
    return http.get(`api/${ApiVersion.V1}/vehicles/vehicles/${id}`);
  },
  getVehicleMakeOptions: ({
    search,
    vehicleType,
  }: {
    search?: string;
    vehicleType?: string;
  }): Promise<AxiosResponse<IVehicleMake[]>> => {
    return http.get(`api/${ApiVersion.V1}/vehicles/makes/options`, {
      params: { search, vehicleType },
    });
  },
  getVehicleModels: (
    makeId: string,
    year: number,
    vehicleType?: string,
  ): Promise<AxiosResponse<IVehicleModel[]>> => {
    return http.get(`api/${ApiVersion.V1}/vehicles/makes/${makeId}/models`, {
      params: { year, vehicleType },
    });
  },
  getVehicleColors: (
    params?: IGetParams,
  ): Promise<AxiosResponse<IListResponse<IVehicleColor>>> => {
    return http.get(`api/${ApiVersion.V1}/vehicles/colors`, { params });
  },
  createVehicleColor: (
    data: IVehicleColor,
  ): Promise<AxiosResponse<IVehicleColor>> => {
    return http.post(`api/${ApiVersion.V1}/vehicles/colors`, data);
  },
  createVehicleMake: (data: {
    name: string;
    externalId: number;
    vehicleType?: string;
  }): Promise<AxiosResponse<IVehicleMake>> => {
    return http.post(`api/${ApiVersion.V1}/vehicles/makes`, data);
  },
  createVehicleModel: (data: {
    name: string;
    make: string;
    year: string | number;
    vehicleType?: string;
  }): Promise<AxiosResponse<IVehicleModel>> => {
    return http.post(`api/${ApiVersion.V1}/vehicles/models`, data);
  },
  createVehicle: (data: IVehicleForm): Promise<AxiosResponse<IVehicle>> => {
    return http.post(`api/${ApiVersion.V1}/vehicles/vehicles`, data);
  },
  updateVehicle: ({
    _id,
    ...data
  }: IVehicleForm): Promise<AxiosResponse<IVehicle>> => {
    return http.put(`api/${ApiVersion.V1}/vehicles/vehicles/${_id}`, data);
  },
  deleteVehicle: (id: string): Promise<AxiosResponse<IVehicle>> => {
    return http.delete(`api/${ApiVersion.V1}/vehicles/vehicles/${id}`);
  },
  getVehicleLicenseStates: (
    params?: IGetParams,
  ): Promise<AxiosResponse<IVehicleLicenseState[]>> => {
    return http.get(`api/${ApiVersion.V1}/vehicles/license-states`, { params });
  },

  getVehicleLicenseTypes: (
    params?: IGetParams,
  ): Promise<AxiosResponse<IVehicleLicenseType[]>> => {
    return http.get(`api/${ApiVersion.V1}/vehicles/license-types`, { params });
  },
};
